import { Component, OnInit } from '@angular/core';
import { UPSISubscriptionService } from '../../services/upsi-subscription.service';
import * as _ from 'lodash';

declare var swal: any;
declare var $: any;

@Component({
  selector: 'app-upsi-subscription-settings',
  templateUrl: './upsi-subscription-settings.component.html',
  styleUrls: ['./upsi-subscription-settings.component.css']
})
export class UPSISubscriptionSettingsComponent implements OnInit {

  companyId: string;
  companyName: string;
  currentSubscription: string = 'UPSI_MAIN';
  isUPSIMain: boolean = true;
  isUPSILite: boolean = false;
  isLoading: boolean = false;
  isSaving: boolean = false;

  constructor(
    private upsiSubscriptionService: UPSISubscriptionService
  ) { }

  ngOnInit() {
    // Get company details from localStorage
    const companyDetails = JSON.parse(localStorage.getItem('companyDetailsGoveva'));
    const userDetails = JSON.parse(localStorage.getItem('user'));
    
    if (companyDetails && companyDetails.value) {
      this.companyId = companyDetails.value;
      this.companyName = companyDetails.label || userDetails.CompanyName;
      this.loadSubscriptionConfig();
    } else {
      swal({
        title: 'Error',
        text: 'Company details not found',
        type: 'error'
      });
    }
  }

  loadSubscriptionConfig() {
    this.isLoading = true;
    
    this.upsiSubscriptionService.getUPSISubscriptionConfig(this.companyId)
      .then((response: any) => {
        this.isLoading = false;
        
        if (response && response.status === 0 && response.data) {
          this.currentSubscription = response.data.SubscriptionType || 'UPSI_MAIN';
          this.isUPSIMain = response.data.IsUPSIMain !== undefined ? response.data.IsUPSIMain : true;
          this.isUPSILite = response.data.IsUPSILite !== undefined ? response.data.IsUPSILite : false;
        }
      })
      .catch(error => {
        this.isLoading = false;
        console.error('Error loading UPSI subscription config:', error);
        swal({
          title: 'Error',
          text: 'Failed to load UPSI subscription configuration',
          type: 'error'
        });
      });
  }

  toggleSubscription() {
    this.isSaving = true;

    const toggleData = {
      CompanyId: this.companyId
    };

    this.upsiSubscriptionService.toggleUPSISubscription(toggleData)
      .then((response: any) => {
        this.isSaving = false;
        
        if (response && response.status === 0 && response.data) {
          this.currentSubscription = response.data.SubscriptionType;
          this.isUPSIMain = response.data.IsUPSIMain;
          this.isUPSILite = response.data.IsUPSILite;

          swal({
            title: 'Success',
            text: response.message || 'UPSI subscription updated successfully',
            type: 'success'
          });

          // Refresh the page after 1.5 seconds to update the menu
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          swal({
            title: 'Error',
            text: 'Failed to update UPSI subscription',
            type: 'error'
          });
        }
      })
      .catch(error => {
        this.isSaving = false;
        console.error('Error toggling UPSI subscription:', error);
        swal({
          title: 'Error',
          text: 'An error occurred while updating the subscription',
          type: 'error'
        });
      });
  }

  saveSubscription(subscriptionType: string) {
    if (subscriptionType === this.currentSubscription) {
      swal({
        title: 'Info',
        text: 'This subscription is already active',
        type: 'info'
      });
      return;
    }

    this.isSaving = true;

    const saveData = {
      CompanyId: this.companyId,
      SubscriptionType: subscriptionType
    };

    this.upsiSubscriptionService.saveOrUpdateUPSISubscriptionConfig(saveData)
      .then((response: any) => {
        this.isSaving = false;
        
        if (response && response.status === 0) {
          this.currentSubscription = response.data.SubscriptionType;
          this.isUPSIMain = response.data.IsUPSIMain;
          this.isUPSILite = response.data.IsUPSILite;

          swal({
            title: 'Success',
            text: response.message || 'UPSI subscription updated successfully',
            type: 'success'
          });

          // Refresh the page after 1.5 seconds to update the menu
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          swal({
            title: 'Error',
            text: 'Failed to update UPSI subscription',
            type: 'error'
          });
        }
      })
      .catch(error => {
        this.isSaving = false;
        console.error('Error saving UPSI subscription:', error);
        swal({
          title: 'Error',
          text: 'An error occurred while saving the subscription',
          type: 'error'
        });
      });
  }

  getSubscriptionLabel(type: string): string {
    return type === 'UPSI_MAIN' ? 'UPSI Main' : 'UPSI Lite';
  }

  getSubscriptionDescription(type: string): string {
    if (type === 'UPSI_MAIN') {
      return 'Full featured UPSI management with all advanced capabilities including bulk operations, advanced analytics, and comprehensive reporting.';
    } else {
      return 'Essential UPSI management features with basic compliance and reporting capabilities.';
    }
  }

}

